import { useState } from 'react';

import { Warrior } from '~/../api/common.types';
import NamingDetails from '~/components/naming/NamingDetails';
import NamingSuccess from '~/components/naming/NamingSuccess';
import {
  calculateMaxLength,
  randomizeSingleName,
} from '~/components/naming/utils';
import Shuffle from '~/components/svgs/Shuffle';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useNameWarrior } from '~/hooks/name/useNameWarrior';
import { getCurrentWarrior, isWarriorNamed } from '~/utils/utils';

const OneName = ({
  warrior,
  level,
}: {
  warrior: Warrior | undefined;
  level: number;
}) => {
  const [value, setValue] = useState('');
  const [successName, setSuccessName] = useState('');
  const [errorMsg, setErrorMessage] = useState('');
  const { accessToken } = useGameAuthentication();
  const {
    mutate: setNameWarriorMutation,
    isLoading,
    isSuccess,
    isError,
  } = useNameWarrior();

  if (!warrior) {
    return <></>;
  }

  const warriorData = getCurrentWarrior(warrior);
  const isNamed = isWarriorNamed(warrior.warrior_json.name, warrior.warrior_id);

  const handleSubmit = (event) => {
    event.preventDefault();
    setNameWarriorMutation(
      {
        id: warrior.warrior_id,
        names: [value],
        token: accessToken,
      },
      {
        onSuccess: (data) => {
          setSuccessName(data.name);
          console.log('data on success', data);
        },
        onError: (err: any) => {
          if (err?.response?.data?.errors) {
            const error = err.response.data['errors'][0];
            if (error?.code === 'naming:already-named') {
              setErrorMessage('Warrior has already been named');
            } else if (error?.code === 'naming:name-unavailable') {
              setErrorMessage('Name is already taken');
            } else {
              // eslint-disable-next-line no-alert
              alert(
                'Something went wrong, please reach out in Discord #dev-tickets'
              );
            }
          }
        },
      }
    );
  };

  if (isSuccess) {
    return <NamingSuccess warrior={warriorData} name={successName} />;
  }
  const handleRandomize = () => {
    const name = randomizeSingleName(warriorData.level);
    setValue(name);
  };

  const maxLength = calculateMaxLength(level);
  return (
    <div className="name-warrior--wrapper">
      <div className="warrior-name mb-space-m">
        <h2 className="warrior-name__text">
          {isNamed ? warriorData.name : value || successName}
        </h2>
        <div className="warrior-name__media">
          <img
            src={
              warriorData.dead ?
                warriorData.images.dead :
                warriorData.images.notActive
            }
            className={warriorData.dead ? 'warrior-name--dead' : ''}
            alt={`Warrior image for ${warriorData.name}`}
          />
        </div>
        {!isNamed && <h4>{warriorData.name}</h4>}
        <NamingDetails warrior={warriorData} />
      </div>

      {!isNamed && (
        <>
          <p className="warrior-name__desc mb-space-s">
            {`Your Warrior is Level ${warriorData.level}.`}
            <br />
            Your name can be up to {maxLength} characters.
          </p>
          <form className="form--naming" action="" onSubmit={handleSubmit}>
            <input
              className="mb-space-xs"
              type="text"
              value={value}
              maxLength={maxLength}
              required={true}
              onChange={(e) => setValue(e.target.value)}
            />

            <div className="button-row">
              <button
                className="button"
                type="submit"
                disabled={isLoading || !value ? true : false}
              >
                {isLoading ? 'Dubbing...' : 'I Dub Thee'}
              </button>
              <button
                className="dice--wrapper"
                onClick={handleRandomize}
                type="button"
              >
                <Shuffle />
              </button>
            </div>
            {isError && <div className="name-error">{errorMsg}</div>}
          </form>
        </>
      )}
    </div>
  );
};

export default OneName;
